import { useEffect, useState } from "react";

const tripKey = (uid) => `vv_trip_cache_${uid}`;

export const isNetworkError = (e) => !e?.response;

const USER_FIELDS = ["id", "name", "role", "avatar_url", "has_access", "trial_active", "trial_days_left", "family_plan", "active_profile", "profiles", "device_limit", "subscription_status"];

// Only non-sensitive display fields are kept on the device for offline use (no email, no tokens).
export function cacheUser(user) {
  const safe = Object.fromEntries(USER_FIELDS.filter((k) => k in user).map((k) => [k, user[k]]));
  localStorage.setItem("vv_user_cache", JSON.stringify(safe));
}

export function cachedUser() {
  try { return JSON.parse(localStorage.getItem("vv_user_cache") || "null"); } catch { return null; }
}

export function saveTrip(uid, items) {
  const safe = items.map(({ user_id, ...rest }) => rest);
  localStorage.setItem(tripKey(uid), JSON.stringify({ at: new Date().toISOString(), items: safe }));
}

export function loadTrip(uid) {
  try { return JSON.parse(localStorage.getItem(tripKey(uid)) || "null"); } catch { return null; }
}

export function clearOfflineData() {
  Object.keys(localStorage).filter((k) => k.startsWith("vv_trip_cache_") || k === "vv_user_cache").forEach((k) => localStorage.removeItem(k));
}

export function useOnline() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true), off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  return online;
}
